import { render } from "./FormConstructorDemo.vue?vue&type=template&id=626c1d00&scoped=true"
import script from "./FormConstructorDemo.vue?vue&type=script&lang=js"
export * from "./FormConstructorDemo.vue?vue&type=script&lang=js"

import "./FormConstructorDemo.vue?vue&type=style&index=0&id=626c1d00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626c1d00"]])

export default __exports__